import React, { useState } from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { getMenuSelect, getUomsMenuSelect, numberWithComma, roundNumber } from 'helpers/format'
import { Col, Dropdown, Image, Row, Space } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import { DeleteOutlined, NumberOutlined, PlusOutlined, PrinterOutlined } from '@ant-design/icons'
import { ImageFallback, PurchaseStatus } from 'helpers/constanst'
import { selectPosBill } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { ActionButton, PrimaryButton } from 'Components/button'
import ProductsDrawer from './ProductsDrawer'
import { PurchaseData, PurchaseProduct } from 'Store/purchase/types'
import { AppInput, AppSelect, MenuPrints } from 'Components/form'
import ReactToPrint from 'react-to-print'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import ProductMultiUoms from 'Pages/Product/components/ProductMultiUoms'
import { Data as UomData } from 'Store/uom/types'
import ProductUomMultiplier from 'Pages/Product/components/ProductUomMultiplier'

type Props = {
  products: PurchaseProduct[]
  onUpdateData?: (products: PurchaseProduct[]) => void
  viewMode?: boolean
  purchasePdfRef?: any
  purchaseLitePdfRef?: any
  recievePdfRef?: any
  recieveLitePDF?: any
  purchasing_no?: string
  detail?: PurchaseData
} & ReduxProps

const ProductsTable: React.FunctionComponent<Props> = props => {
  const [chooseProduct, setChooseProduct] = useState(false)
  const [defaultAmountModal, setDefaultAmountModal] = useState(false)
  const [defaultAmount, setDefaultAmount] = useState(0)
  const {
    products,
    onUpdateData = () => {},
    viewMode = false,
    purchasePdfRef,
    recievePdfRef,
    purchaseLitePdfRef,
    purchasing_no = '',
    detail,
    recieveLitePDF,
  } = props

  const showPickUpInfo =
    detail?.status !== PurchaseStatus.DRAFT &&
    detail?.status !== PurchaseStatus.CANCEL &&
    detail?.status !== PurchaseStatus.PENDING &&
    viewMode

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const onUpdateQuantity = (product: PurchaseProduct, val: string) => {
    const newProduct = products.map(item => {
      if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
        item.amount = parseInt(val)
      }
      return item
    })
    onUpdateData(newProduct)
  }

  const onUpdateUom = (product: PurchaseProduct, val: string) => {
    const newProduct = products.map(item => {
      if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
        const uomInfo = item.uoms?.find(uom => uom.id === parseInt(val))
        item.product_uom_id = parseInt(val)
        item.price_per_unit = uomInfo?.purchase_price || 0
        item.product_uom = uomInfo?.uom_name || ''
      }
      return item
    })
    onUpdateData(newProduct)
  }

  const onUpdatePrice = (product: PurchaseProduct, val: number) => {
    //alert(val)
    const newProduct =
      products &&
      products.map(item => {
        if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
          item.price_per_unit = val
        }
        return item
      })
    onUpdateData(newProduct)
  }

  const onRemoveProduct = (product: PurchaseProduct) => {
    const newProduct =
      products &&
      products.filter(
        item => item.product_id != product.product_id || item.product_option_id != product.product_option_id,
      )
    onUpdateData(newProduct)
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: string, record: PurchaseProduct) => {
    const isSameTitle = record.product_name == record.product_option_name
    return (
      <>
        <RowTile>{record.product_name}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_name}</ProductDesc>}
      </>
    )
  }

  const renderActionButton = (text: string, record: any) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="view"
        onClick={() => onRemoveProduct(record)}
      />
    </Space>
  )

  const renderQuantity = (item: string, record: PurchaseProduct) => {
    if (viewMode) {
      return numberWithComma(record.amount)
    } else {
      return (
        <AppInput
          name="amount"
          label=""
          type="number"
          errorMsg="จำนวน"
          isRequired={true}
          isError={isNaN(record.amount) || record.amount <= 0}
          value={record.amount}
          onChange={val => onUpdateQuantity(record, val)}
          key={`${record.product_id}-${record.product_option_id}`}
        />
      )
    }
  }

  const renderRecieveInfo = (item: string, record: PurchaseProduct) => {
    if (!showPickUpInfo) return
    return <ProductRecieve>{numberWithComma(record.received_amount || 0)}</ProductRecieve>
  }

  const renderRemaincieveInfo = (item: string, record: PurchaseProduct) => {
    if (!showPickUpInfo) return
    const remain = (record?.amount || 0) - (record?.received_amount || 0)
    if (remain <= 0) return 0
    return <ProductRemain>{numberWithComma(remain || 0)}</ProductRemain>
  }

  const renderPrice = (item: string, record: PurchaseProduct) => {
    if (viewMode) {
      return numberWithComma(record.price_per_unit, true)
    } else {
      return (
        <AppInput
          name="price_per_unit"
          label=""
          //type="number"
          errorMsg="ราคาต่อหน่วย"
          isRequired={true}
          isError={isNaN(record.price_per_unit) || record.price_per_unit <= 0}
          value={record.price_per_unit}
          onChange={val => onUpdatePrice(record, val)}
          key={`${record.product_id}-${record.product_option_id}`}
        />
      )
    }
  }

  const renderTotalPrice = (item: string, record: PurchaseProduct) => {
    return <TextRight>{numberWithComma((record.amount || 0) * (record.price_per_unit || 0), true)}</TextRight>
  }

  const renderProductUom = (uom: string, record: PurchaseProduct) => {
    const uoms = record?.uoms || []
    if (viewMode || uoms.length <= 1) {
      const master = uoms?.find(item => item.is_master)
      const current = uoms?.find(item => item.id === record.product_uom_id)
      return (
        <span>
          <ProductUomMultiplier masterUom={master} quantity={record.amount || 0} currentUom={current} />
        </span>
      )
    } else {
      return (
        <Row gutter={[8, 8]} align="middle">
          <Col md={20}>
            <AppSelect
              name="product_uom_id"
              label=""
              errorMsg="หน่วย"
              isRequired={true}
              isError={!record?.product_uom_id}
              value={record.product_uom_id}
              onChange={val => onUpdateUom(record, val)}
              menu={getUomsMenuSelect(uoms)}
              key={`${record.product_id}-${record.product_option_id}`}
              allowClear={false}
            />
          </Col>
          <Col md={4}>
            <ProductMultiUoms uoms={uoms} showPurchasePrice showQuantity={true} showMaster label={' '} />
          </Col>
        </Row>
      )
    }
  }

  const columns = [
    {
      title: <ColTile>ลำดับ</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '50px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'product_photo',
      key: 'product_photo',
      width: '80px',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'product_sku',
      key: 'product_sku',
      width: '100px',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'product_manufacture',
      key: 'product_manufacture',
      width: '100px',
      render: (value: any) => renderInfo(value || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'product_name',
      key: 'product_name',
      render: renderProductName,
      width: '150px',
    },
    {
      title: <ColTile>จำนวน</ColTile>,
      dataIndex: 'amount',
      key: 'amount',
      width: showPickUpInfo ? '60px' : '150px',
      render: renderQuantity,
    },
    {
      title: <ColTile>หน่วย</ColTile>,
      dataIndex: 'product_uom',
      key: 'product_uom',
      width: viewMode ? '80px' : '200px',
      render: renderProductUom,
    },
    {
      title: showPickUpInfo ? <ColTile>รับแล้ว</ColTile> : '',
      dataIndex: 'received_amount',
      key: 'received_amount',
      width: showPickUpInfo ? '60px' : '0px',
      render: renderRecieveInfo,
    },
    {
      title: showPickUpInfo ? <ColTile>ค้างรับ</ColTile> : '',
      dataIndex: 'amount',
      key: 'remain',
      width: showPickUpInfo ? '60px' : '0px',
      render: renderRemaincieveInfo,
    },
    {
      title: <ColTile>ต้นทุนต่อหน่วย</ColTile>,
      dataIndex: 'price_per_unit',
      key: 'price_per_unit',
      width: '150px',
      render: renderPrice,
    },
    {
      title: (
        <ColTile>
          <TextRight>ราคารวม</TextRight>
        </ColTile>
      ),
      dataIndex: 'total_discount',
      key: 'total_discount',
      render: renderTotalPrice,
      width: '100px',
    },
    {
      title: '',
      key: 'action',
      width: '50px',
      render: !viewMode && renderActionButton,
    },
  ]

  const ChooseProductsDrawer = (
    <ProductsDrawer
      visible={chooseProduct}
      onCloseDrawer={() => setChooseProduct(false)}
      onSaveProduct={(products: PurchaseProduct[]) => {
        onUpdateData(products)
        setChooseProduct(false)
      }}
      products={products}
    />
  )

  const countTotal = () => {
    let amount = 0
    let price = 0
    products &&
      products.forEach(item => {
        const totalPrice = (item.amount || 0) * (item.price_per_unit || 0)
        amount += item.amount
        price += totalPrice
      })
    return { amount, price }
  }

  const onUpdateDefaultAmount = (val: string) => {
    setDefaultAmount(parseInt(val))
  }

  const renderAmountModal = () => {
    return (
      <AppInput
        name="amount"
        label="ระบุจำนวน"
        type="number"
        errorMsg="จำนวน"
        isRequired={false}
        isError={false}
        value={defaultAmount}
        onChange={onUpdateDefaultAmount}
      />
    )
  }

  const onSaveAmount = () => {
    const newProduct = products?.map((item: any) => {
      item.amount = defaultAmount
      return item
    })
    onUpdateData(newProduct)
    setDefaultAmountModal(false)
  }

  const DefaultAmountModal = (
    <ConfirmWithChild
      title={'ระบุจำนวนเท่ากันทุกรายการ'}
      isShow={defaultAmountModal}
      handleOk={onSaveAmount}
      handleCancel={() => setDefaultAmountModal(false)}
      child={renderAmountModal()}
      cancelBtnTxt="ปิด"
    />
  )

  const renderHeader = () => {
    const status = detail?.status
    if (viewMode) {
      return (
        <Row justify="space-between" gutter={[32, 32]} align="middle">
          <Col>
            <BoxTitle>สรุปรายละเอียดใบสั่งซื้อ</BoxTitle>
          </Col>
          {status !== PurchaseStatus.CANCEL && (
            <Col>
              <Space>
                <Dropdown
                  key="more"
                  overlay={
                    <MenuPrints
                      nomalPrintRef={purchasePdfRef}
                      litePrintRef={purchaseLitePdfRef}
                      title={`ใบสั่งซื้อ-${purchasing_no}`}
                    />
                  }
                  trigger={['click', 'hover']}
                >
                  <PrimaryButton
                    btnType="Approve"
                    text="ใบสั่งซื้อ"
                    icon={<PrinterOutlined />}
                    onClick={() => {}}
                    size="middle"
                    className="ttr-print"
                  />
                </Dropdown>
                <Dropdown
                  key="more"
                  overlay={
                    <MenuPrints
                      nomalPrintRef={recievePdfRef}
                      litePrintRef={recieveLitePDF}
                      title={`ใบรับสินค้า-${purchasing_no}`}
                    />
                  }
                  trigger={['click', 'hover']}
                >
                  <PrimaryButton
                    btnType="Primary"
                    text="ใบรับสินค้า"
                    icon={<PrinterOutlined />}
                    onClick={() => {}}
                    size="middle"
                  />
                </Dropdown>
              </Space>
            </Col>
          )}
        </Row>
      )
    } else {
      return (
        <Row justify="space-between" gutter={[32, 32]} align="middle">
          <Col>
            <Space direction="vertical">
              <BoxTitle>
                เลือกสินค้าสำหรับออกใบสั่งซื้อ (จำนวนสินค้าที่เลือก {products?.length || 0} รายการ)
              </BoxTitle>
            </Space>
          </Col>
          <Col>
            <Space>
              {products.length > 1 && (
                <Space>
                  <PrimaryButton
                    btnType="Approve"
                    text="ระบุจำนวนเท่ากันทุกรายการ"
                    icon={<NumberOutlined />}
                    onClick={() => {
                      setDefaultAmount(0)
                      setDefaultAmountModal(true)
                    }}
                    size="middle"
                  />
                </Space>
              )}
              {status !== PurchaseStatus.DRAFT && purchasing_no && (
                <ReactToPrint
                  trigger={() => {
                    return (
                      <PrimaryButton
                        btnType="Primary"
                        text="ใบสั่งซื้อ"
                        icon={<PrinterOutlined />}
                        onClick={() => {}}
                        size="middle"
                        className="ttr-print"
                      />
                    )
                  }}
                  content={() => purchasePdfRef.current}
                  documentTitle={`ใบสั่งซื้อสินค้า(ชั่วคราว)-${purchasing_no}`}
                />
              )}
            </Space>
          </Col>
        </Row>
      )
    }
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          {renderHeader()}
          <TableListPage
            rowKey="option_id"
            tableName="product-purchase"
            columns={columns}
            datas={products}
            size={'small'}
          />
        </Col>
      </Row>
      <Row justify="space-between" gutter={[8, 8]}>
        <Col>
          {!viewMode && (
            <PrimaryButton
              btnType="Approve"
              text="เพิ่มสินค้า"
              onClick={() => setChooseProduct(true)}
              icon={<PlusOutlined />}
              size="middle"
            />
          )}
        </Col>
        {/* {products?.length > 0 && (
          <Col>
            <AppInput
              name="amount"
              label="ระบุจำนวนเท่ากัน"
              type="number"
              errorMsg="จำนวน"
              isRequired={false}
              isError={false}
              value={defaultAmount}
              onChange={onUpdateDefaultAmount}
            />
          </Col>
        )} */}
        <Col>
          <SummaryPrice>
            <Space>
              <InfoTitle>จำนวนเงินรวมทั้งสิ้น</InfoTitle>
              <Price> {numberWithComma(countTotal().price, true)} บาท </Price>
            </Space>
          </SummaryPrice>
        </Col>
      </Row>
      {ChooseProductsDrawer}
      {DefaultAmountModal}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const SummaryPrice = styled.div`
  margin-right: 50px;
  text-align: right;
`

const Price = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title2};
`

const TextRight = styled.div`
  text-align: right;
`

const ProductRemain = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const ProductRecieve = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.success};
`

const mapStateToProps = (state: RootState) => {
  return {
    billData: selectPosBill(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsTable)
